const DATE_ADDED = {
    key: 'dateadded',
    label: 'Date contact added',
    type: 'date',
    modifier: 'within',
    value: '',
    query: '',
};

const DATE_SENT = {
    key: 'email_sent_on',
    label: 'Date email sent',
    type: 'date',
    modifier: 'within',
    value: '',
    query: '',
};

const DATE_PAID = {
    key: 'datepaid',
    label: 'Date of payment',
    type: 'date',
    modifier: 'within',
    value: '',
    query: '',
};

const TAGS = {
    key: 'tags',
    label: 'Tags applied to contact',
    type: 'tags',
    modifier: 'includesany',
    value: '',
    query: '',
};

const EMAIL_DOMAIN = {
    key: 'emaildomain',
    label: 'Email domain',
    type: 'text',
    modifier: 'equals',
    value: '',
    query: '',
};

const CONTACT_TYPE = {
    key: 'contacttype',
    label: 'Contact type',
    type: 'contacttype',
    modifier: 'equals',
    value: '',
    query: '',
};

const COUNTRY = {
    key: 'country',
    label: 'Country',
    type: 'text',
    modifier: 'equals',
    value: '',
    query: '',
};

const STATE = {
    key: 'state',
    label: 'State',
    type: 'text',
    modifier: 'equals',
    value: '',
    query: '',
};

const CITY = {
    key: 'city',
    label: 'City',
    type: 'text',
    modifier: 'equals',
    value: '',
    query: '',
};

const POSTAL_CODE = {
    key: 'postalcode',
    label: 'Postal code',
    type: 'text',
    modifier: 'equals',
    value: '',
    query: '',
};

const ANNIVERSARY = {
    key: 'anniversary',
    label: 'Anniversary',
    type: 'date',
    modifier: 'between',
    value: '',
    query: '',
};

const AMOUNT_PAID = {
    key: 'totalamountpaid',
    label: 'Amount of Payment',
    type: 'currency',
    modifier: 'greaterthan',
    value: '',
    query: '',
};

const BROADCAST_OR_CAMPAIGN = {
    key: 'broadcastorcampaign',
    label: 'Broadcast or Campaign',
    type: 'select',
    modifier: 'equals',
    value: 'Broadcast',
    query: 'Broadcast',
    valueOptions: [
        { label: 'Broadcast', value: 'Broadcast' },
        { label: 'Campaign', value: 'Campaign' },
    ],
};

export const CONTACT_GROWTH_FILFTER_OPTIONS = [
    DATE_ADDED,
    TAGS,
    EMAIL_DOMAIN,
    CONTACT_TYPE,
    COUNTRY,
    STATE,
    CITY,
    POSTAL_CODE,
    ANNIVERSARY,
];

export const EMAIL_DELIVERABILITY_FILTER_OPTIONS = [
    DATE_SENT,
    BROADCAST_OR_CAMPAIGN,
];

export const PAYMENTS_FILTER_OPTIONS = [
    DATE_PAID,
    AMOUNT_PAID,
    TAGS,
];

export const DATE_MODIFERS = [
    { value: 'between', label: 'Between' },
    { value: 'before', label: 'Before' },
    { value: 'after', label: 'After' },
    { value: 'within', label: 'Within (days ago)' },
];

export const TEXT_MODIFERS = [
    { value: 'equals', label: 'Equals' },
    { value: 'notequals', label: 'Not equals' },
    { value: 'contains', label: 'Contains' },
    { value: 'notcontain', label: 'Does not contain' },
    { value: 'startswith', label: 'Starts with' },
    { value: 'endswith', label: 'Ends with' },
    { value: 'isempty', label: 'Is empty' },
    { value: 'isfilled', label: 'Is filled' },
];

export const CONTACT_TYPE_MODIFERS = [
    { value: 'equals', label: 'Equals' },
    { value: 'notequals', label: 'Not equals' },
    { value: 'isempty', label: 'Is empty' },
    { value: 'isfilled', label: 'Is filled' },
];

export const TAGS_MODIFERS = [
    { value: 'includesany', label: 'Includes any' },
    { value: 'excludesall', label: 'Excludes all' },
];

export const SELECT_MODIFERS = [
    { value: 'equals', label: 'Equals' },
];

export const CURRENCY_MODIFERS = [
    { value: 'greaterthan', label: 'Greater than' },
    { value: 'lessthan', label: 'Less than' },
    { value: 'between', label: 'Between' },
    { value: 'equals', label: 'Equals' },
];
